import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, Fragment as _Fragment, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "p-toppage__info" }
const _hoisted_2 = { class: "p-toppage__info__wrap" }
const _hoisted_3 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingContent = _resolveComponent("LoadingContent")!
  const _component_CMS = _resolveComponent("CMS")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.error)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.error), 1))
        : _createCommentVNode("", true),
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_LoadingContent, { key: 1 }))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            (_ctx.tab_id === 0)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_CMS, {
                    contents_type: "block_contents",
                    location_code: "IC_MENUTOP_02_01_005_specialtitle"
                  }),
                  _createVNode(_component_CMS, {
                    contents_type: "block_contents",
                    location_code: "IC_MENUTOP_02_01_006_special"
                  })
                ], 64))
              : (_ctx.tab_id === 1)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(_component_CMS, {
                      contents_type: "block_contents",
                      location_code: "IC_MENUTOP_02_02_005_specialtitle"
                    }),
                    _createVNode(_component_CMS, {
                      contents_type: "block_contents",
                      location_code: "IC_MENUTOP_02_02_006_special"
                    })
                  ], 64))
                : _createCommentVNode("", true)
          ], 64))
    ])
  ]))
}